import { PAY_METHOD_TYPE, PAY_METHOD_TYPE_TEXT, PAYMENT_METHOD_TYPE_TO_KEY } from './orderConstants';

/**
 *  페이지 이름
 */
export const PRODUCT_PAGE_NAME = {
  PRODUCT_ALL_LIST: '상품 전체 리스트',
  PRODUCT_APPROVAL_LIST: '상품 승인 리스트',
  PRODUCT_BAN_LIST: '상품 금지 리스트',
  PRODUCT_PROPERTY_REQUEST_LIST: '상품 속성 검수 리스트',
  PRODUCT_CREATE: '상품 등록',
  PRODUCT_BULK_EDIT: '상품 일괄 편집',
  PRODUCT_DETAIL: '상품 상세',
  PRODUCT_EDIT: '상품 편집',
  PRODUCT_VERSION: '상품 버전 비교',
  PRODUCT_COPY: '상품 복사',
};

/**
 *  할인 방법 타입
 */
export const DISCOUNT_TYPE = {
  FIXED_AMOUNT_DISCOUNT: 0,
  FIXED_RATE_DISCOUNT: 1,
};

/**
 *  상품 할인 설정 TEXT
 */
export const DISCOUNT_TYPE_TEXT = {
  0: '정액 할인',
  1: '정률 할인',
};

/**
 *  상품 할인 설정 SELECT 리스트
 */
export const DISCOUNT_TYPE_SELECT_LIST = [
  {
    id: 0,
    name: '원',
  },
  {
    id: 1,
    name: '%',
  },
];

/**
 * 상품 정렬 필터 타입
 */
export const PRODUCT_SORT_TYPE = {
  RECOMMENDATION: 'recommendation',
  POPULAR: 'popular',
  LATEST: 'latest',
  LOW_PRICE: 'lowPrice',
  HIGH_PRICE: 'highPrice',
} as const;

/**
 *  상품 상태
 */
export const PRODUCT_STATUS = {
  /**
   *  승인 대기
   */
  CONFIRM_READY: 0,
  /**
   *  승인 거절
   */
  CONFIRM_REJECT: 1,
  /**
   *  판매 중
   */
  NOW_ON_SALE: 2,
  /**
   *  품절
   */
  SOLD_OUT: 3,
  /**
   *  판매 종료
   */
  SALES_CLOSE: 4,
  /**
   *  판매 금지
   */
  SALES_PROHIBIT: 5,
  /**
   *  판매 대기
   */
  SALES_READY: 6,
  /**
   *  판매 중지
   */
  SALES_STOP: 7,
  /**
   *  상품 삭제
   */
  DELETE: 8,
};

export const PRODUCT_STATUS_STR = {
  NOW_ON_SALE: 'nowOnSale',
  SOLD_OUT: 'soldOut',
  SALES_CLOSE: 'salesClose',
  SALES_PROHIBIT: 'salesProhibit',
  SALES_READY: 'salesReady',
  SALES_STOP: 'salesStop',
  DELETE: 'delete',
} as const;

/**
 *  상품 상태 TEXT
 */
export const PRODUCT_STATUS_TEXT: { [p: string | number]: string } = {
  [PRODUCT_STATUS.CONFIRM_READY]: '승인 대기',
  [PRODUCT_STATUS.CONFIRM_REJECT]: '승인 거절',
  [PRODUCT_STATUS.NOW_ON_SALE]: '판매 중',
  [PRODUCT_STATUS.SOLD_OUT]: '품절',
  [PRODUCT_STATUS.SALES_CLOSE]: '판매 종료',
  [PRODUCT_STATUS.SALES_PROHIBIT]: '판매 금지',
  [PRODUCT_STATUS.SALES_READY]: '판매 대기',
  [PRODUCT_STATUS.SALES_STOP]: '판매 중지',
  [PRODUCT_STATUS.DELETE]: '상품 삭제',
  [PRODUCT_STATUS_STR.NOW_ON_SALE]: '판매 중',
  [PRODUCT_STATUS_STR.SOLD_OUT]: '품절',
  [PRODUCT_STATUS_STR.SALES_CLOSE]: '판매 종료',
  [PRODUCT_STATUS_STR.SALES_PROHIBIT]: '판매 금지',
  [PRODUCT_STATUS_STR.SALES_READY]: '판매 대기',
  [PRODUCT_STATUS_STR.SALES_STOP]: '판매 중지',
  [PRODUCT_STATUS_STR.DELETE]: '상품 삭제',
};

/**
 *  상품 상태 SELECT 리스트
 */
export const PRODUCT_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_STATUS.CONFIRM_READY,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.CONFIRM_READY],
  },
  {
    id: PRODUCT_STATUS.CONFIRM_REJECT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.CONFIRM_REJECT],
  },
  {
    id: PRODUCT_STATUS.NOW_ON_SALE,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.NOW_ON_SALE],
  },
  {
    id: PRODUCT_STATUS.SOLD_OUT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SOLD_OUT],
  },
  {
    id: PRODUCT_STATUS.SALES_CLOSE,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_CLOSE],
  },
  {
    id: PRODUCT_STATUS.SALES_PROHIBIT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_PROHIBIT],
  },
  {
    id: PRODUCT_STATUS.SALES_READY,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_READY],
  },
  {
    id: PRODUCT_STATUS.SALES_STOP,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_STOP],
  },
  {
    id: PRODUCT_STATUS.DELETE,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.DELETE],
  },
];

/**
 *  상품 속성 검수 상태 SELECT 리스트
 */
export const PRODUCT_PROPERTY_REQUEST_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_STATUS.NOW_ON_SALE,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.NOW_ON_SALE],
  },
  {
    id: PRODUCT_STATUS.SOLD_OUT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SOLD_OUT],
  },
  {
    id: PRODUCT_STATUS.SALES_PROHIBIT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_PROHIBIT],
  },
  {
    id: PRODUCT_STATUS.SALES_STOP,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_STOP],
  },
];

/**
 *  상품 편집 페이지에서 상품 상태를 변경할 수 있는 상품 상태
 *  2(판매중), 3(품절), 7(판매 중지)
 */
export const ENABLE_CHANGE_PRODUCT_STATUS_LIST = [
  PRODUCT_STATUS.NOW_ON_SALE,
  PRODUCT_STATUS.SOLD_OUT,
  PRODUCT_STATUS.SALES_STOP,
];

/**
 *  상품 편집 페이지에서 상품 상태를 변경할 수 있는 상품 상태 SELECT 리스트
 */
export const ENABLE_CHANGE_PRODUCT_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_STATUS.NOW_ON_SALE,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.NOW_ON_SALE],
  },
  {
    id: PRODUCT_STATUS.SOLD_OUT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SOLD_OUT],
  },
  {
    id: PRODUCT_STATUS.SALES_STOP,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SALES_STOP],
  },
];

/**
 *  상품 복사 페이지에서 상품 상태를 변경할 수 있는 상품 상태 SELECT 리스트
 */
export const PRODUCT_COPY_ENABLE_CHANGE_PRODUCT_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_STATUS.CONFIRM_READY,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.CONFIRM_READY],
  },
];

/**
 *  상품 옵션 KEY SELECT 리스트
 */
export const PRODUCT_OPTION_NAME_SELECT_LIST = [
  {
    id: 0,
    name: '직접 입력',
  },
  {
    id: 1,
    name: '크기',
  },
  {
    id: 2,
    name: '종류',
  },
  {
    id: 3,
    name: '색상',
  },
  {
    id: 4,
    name: '색상/침',
  },
  {
    id: 5,
    name: '색상/크기',
  },
  {
    id: 6,
    name: '침',
  },
  {
    id: 7,
    name: '호수',
  },
  {
    id: 8,
    name: '길이',
  },
  {
    id: 9,
    name: '소재',
  },
];

/**
 *  상품 승인 거절 타입
 */
export const PRODUCT_REJECT_TYPE = {
  /**
   *  카테고리 부적합
   */
  CATEGORY: 0,
  /**
   *  상품명 부적합
   */
  PRODUCT_NAME: 1,
  /**
   *  상품 옵션 부적합
   */
  OPTION: 2,
  /**
   *  상세페이지 부적합
   */
  DETAIL_PAGE: 3,
  /**
   *  카테고리 부적합
   */
  IMAGE: 4,
  /**
   *  상품정보제공 공시 부적합
   */
  INFO: 5,
  /**
   *  A/S 부적합
   */
  AS: 6,
  /**
   *  상품 태그 부적합
   */
  TAG: 7,
  /**
   *  기타
   */
  ETC: 8,
};

/**
 *  상품 승인 거절 타입 TEXT
 */
export const PRODUCT_REJECT_TYPE_TEXT = {
  [PRODUCT_REJECT_TYPE.CATEGORY]: '카테고리 부적합',
  [PRODUCT_REJECT_TYPE.PRODUCT_NAME]: '상품명 부적합',
  [PRODUCT_REJECT_TYPE.OPTION]: '상품 옵션 부적합',
  [PRODUCT_REJECT_TYPE.DETAIL_PAGE]: '상세페이지 부적합',
  [PRODUCT_REJECT_TYPE.IMAGE]: '이미지 부적합',
  [PRODUCT_REJECT_TYPE.INFO]: '상품정보제공 공시 부적합',
  [PRODUCT_REJECT_TYPE.AS]: 'A/S 부적합',
  [PRODUCT_REJECT_TYPE.TAG]: '상품 태그 부적합',
  [PRODUCT_REJECT_TYPE.ETC]: '기타',
};

/**
 *  상품 승인 거절 타입 SELECT 리스트
 */
export const PRODUCT_REJECT_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: PRODUCT_REJECT_TYPE.CATEGORY,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.CATEGORY],
  },
  {
    id: PRODUCT_REJECT_TYPE.PRODUCT_NAME,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.PRODUCT_NAME],
  },
  {
    id: PRODUCT_REJECT_TYPE.OPTION,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.OPTION],
  },
  {
    id: PRODUCT_REJECT_TYPE.DETAIL_PAGE,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.DETAIL_PAGE],
  },
  {
    id: PRODUCT_REJECT_TYPE.IMAGE,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.IMAGE],
  },
  {
    id: PRODUCT_REJECT_TYPE.INFO,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.INFO],
  },
  {
    id: PRODUCT_REJECT_TYPE.AS,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.AS],
  },
  {
    id: PRODUCT_REJECT_TYPE.TAG,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.TAG],
  },
  {
    id: PRODUCT_REJECT_TYPE.ETC,
    name: PRODUCT_REJECT_TYPE_TEXT[PRODUCT_REJECT_TYPE.ETC],
  },
];

/**
 *  금지된 상품 상태
 */
export const CONFIRM_PRODUCT_STOP_REQUEST_STATUS = {
  /**
   *  판매 금지
   */
  BAN: 0,
  /**
   *  재승인 요청
   */
  REQUEST: 1,
};

/**
 *  금지된 상품 상태 TEXT
 */
export const CONFIRM_PRODUCT_STOP_REQUEST_STATUS_TEXT = {
  0: '판매 금지',
  1: '재승인 요청',
};

/**
 *  금지된 상품 상태 SELECT 리스트
 */
export const CONFIRM_PRODUCT_STOP_REQUEST_STATUS_SELECT_LIST = [
  {
    id: 0,
    name: '판매 금지',
  },
  {
    id: 1,
    name: '재승인 요청',
  },
];

/**
 *  상품 상세 페이지 타입
 */
export const PRODUCT_DETAIL_PAGE_TYPE = {
  /**
   *  상세
   */
  DETAIL: 0,
  /**
   *  등록
   */
  CREATE: 1,
  /**
   *  편집
   */
  EDIT: 2,
  /**
   *  복사
   */
  COPY: 3,
};

/**
 *  상품 상세 페이지 패널 name
 */
export const PRODUCT_DETAIL_PAGE_PANEL_NAME = {
  /**
   *  상품 상태 및 브랜드 정보
   */
  PRO_STATUS_AND_BRAND_INFO: 'pro-status-and-store-info',
  /**
   *  카테고리
   */
  PRO_CATEGORY: 'pro-category',
  /**
   *  상품 속성
   */
  PRO_PROPERTY: 'pro-property',
  /**
   *  상품명, 가격, 할인정보
   */
  PRO_NAME_AND_PRICE: 'pro-name-and-price',
  /**
   *  재고/옵션
   */
  PRO_STOCK_AND_OPTION: 'pro-stock-and-option',
  /**
   *  상품 결제 정보
   */
  PRO_PAY_METHOD: 'pro-pay-method',
  /**
   *  상품 태그 정보
   */
  PRO_TAG_INFO: 'pro-tag-info',
  /**
   *  상품 이미지
   */
  PRO_IMG: 'pro-img',
  /**
   *  상품 상세 설명
   */
  PRO_DESCRIPTION_IMG: 'pro-description-img',
  /**
   *  배송 정보
   */
  PRO_DELIVERY_INFO: 'pro-delivery-info',
  /**
   *  A/S 정보
   */
  PRO_AFTER_SERVICE: 'pro-after-service',
  /**
   * 외부채널
   */
  PRO_EXTERNAL_CHANNEL: 'pro-external-channel',
  /**
   * 커스텀 속성
   */
  PRO_CUSTOM_ATTRIBUTE: 'pro-custom-attribute',
};

/**
 *  상품 옵션 상태
 */
export const PRODUCT_OPTION_STATUS = {
  /**
   *  비 노출
   */
  IN_ACTIVE: 0,
  /**
   *  노출
   */
  ACTIVE: 1,
  /**
   *  품절
   */
  SOLD_OUT: 2,
  /**
   *  삭제
   */
  DELETE: 3,
};

/**
 *  상품 옵션 상태 TEXT
 */
export const PRODUCT_OPTION_STATUS_TEXT = {
  [PRODUCT_OPTION_STATUS.IN_ACTIVE]: '비 노출',
  [PRODUCT_OPTION_STATUS.ACTIVE]: '노출',
  [PRODUCT_OPTION_STATUS.SOLD_OUT]: '품절',
  [PRODUCT_OPTION_STATUS.DELETE]: '삭제',
};

/**
 *  상품 옵션 상태 TEXT
 */
export const PRODUCT_OPTION_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_OPTION_STATUS.IN_ACTIVE,
    name: PRODUCT_OPTION_STATUS_TEXT[PRODUCT_OPTION_STATUS.IN_ACTIVE],
  },
  {
    id: PRODUCT_OPTION_STATUS.ACTIVE,
    name: PRODUCT_OPTION_STATUS_TEXT[PRODUCT_OPTION_STATUS.ACTIVE],
  },
  {
    id: PRODUCT_OPTION_STATUS.SOLD_OUT,
    name: PRODUCT_OPTION_STATUS_TEXT[PRODUCT_OPTION_STATUS.SOLD_OUT],
  },
];

/**
 *  상품 카테고리명
 */
export const PRODUCT_CATEGORY_NAME = {
  EARRING: '귀걸이',
  NECKLACE: '목걸이',
  RING: '반지',
  BRACELET: '팔찌',
  PIERCING: '피어싱',
  ANKLET: '발찌',
  HAIR: '헤어',
  ETC: '기타소품',
  FASHION_GOODS: '패션잡화',
  TIMEPIECE: '타임피스',
  DIGITAL: 'DIGITAL',
};

/**
 * 상품 속성 key
 */
export const PRODUCT_PROPERTY_KEY = {
  MAIN_MATERIAL: 'mainMaterial',
  PLATE_MATERIAL: 'plateMaterial',
  STONE_MATERIAL: 'stoneMaterial',
  ACUPUNCTURE_MATERIAL: 'acupunctureMaterial',
  OTHER_MATERIAL: 'otherMaterial',
  MAIN_COLOR: 'mainColor',
  DECORATIVE_FIGURE: 'decorativeFigure',
  CHAIN_SHAPE: 'chainShape',
};

/**
 * 상품 태그 key
 */
export const PRODUCT_TAG_KEY = {
  CONCEPT_TAG: 'conceptTag',
  SEASON_SITUATION_TAG: 'seasonSituationTag',
};

/**
 *  판매가가 2,000원 이상만 올릴 수 있는 카테고리명 리스트
 */
export const MINIMUM_PRICE_2000_WON_CATEGORY_NAME_LIST = [
  PRODUCT_CATEGORY_NAME.HAIR,
  PRODUCT_CATEGORY_NAME.ETC,
  PRODUCT_CATEGORY_NAME.FASHION_GOODS,
  PRODUCT_CATEGORY_NAME.TIMEPIECE,
  PRODUCT_CATEGORY_NAME.DIGITAL,
];

/**
 *  체인 모양 태그를 입력 할 수 있는 카테고리명 리스트
 */
export const AVAILABLE_CHAIN_SHAPE_TAG_CATEGORY_NAME_LIST = [
  PRODUCT_CATEGORY_NAME.NECKLACE,
  PRODUCT_CATEGORY_NAME.BRACELET,
  PRODUCT_CATEGORY_NAME.ANKLET,
];

/**
 *  상품명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_NAME = 50;

/**
 *  상품 최소 가격
 */
export const PRODUCT_MINIMUM_PRICE = 2000;

/**
 *  판매가가 9,900원 이상만 올릴 수 있는 카테고리 상품 최소 가격
 */
export const MINIMUM_PRICE_9900_WON_CATEGORY_PRICE = 9900;

/**
 *  상품 최대 가격
 */
export const PRODUCT_MAXIMUM_PRICE = 9999990;

/**
 *  상품 최소 할인액
 */
export const PRODUCT_MINIMUM_DISCOUNT_AMOUNT = 10;

/**
 *  상품 최소 할인율
 */
export const PRODUCT_MINIMUM_DISCOUNT_RATE = 1;

/**
 *  상품 최대 할인율
 */
export const PRODUCT_MAXIMUM_DISCOUNT_RATE = 99;

/**
 *  상품 최대 재고량
 */
export const PRODUCT_MAXIMUM_STOCK = 10000000;

/**
 *  상품 최대 재고량
 */
export const PRODUCT_MINIMUM_STOCK = 0;

/**
 *  상품 제품 번호 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_NUMBER_TEXT = 100;

/**
 *  상품 스타일 코드 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_STYLE_CODE_TEXT = 250;

/**
 *  상품 옵선 명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_OPTION_NAME_TEXT = 25;

/**
 *  상품 옵선 값 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_OPTION_VALUE_TEXT = 50;

/**
 *  상품 옵선 값 CSV 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_OPTION_VALUE_CSV_TEXT = 1000;

/**
 *  상품 사이즈 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_SIZE_TEXT = 50;

/**
 *  상품 중량 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_WEIGHT_TEXT = 30;

/**
 *  상품 구매 시 유의 사항 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_NOTICE_TEXT = 100;

/**
 *  상품 중량 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_AS_INFORM_TEXT = 3000;

/**
 *  입력받는 상품 썸네일 이미지 최소 너비
 */
export const MINIMUM_WIDTH_OF_INPUT_PRODUCT_THUMBNAIL_IMG = 600;

/**
 *  입력받는 상품 썸네일 이미지 최소 높이
 */
export const MINIMUM_HEIGHT_OF_INPUT_PRODUCT_THUMBNAIL_IMG = 600;

/**
 *  S3 에 저장 될 상품 썸네일 이미지 너비
 */
export const PRODUCT_THUMBNAIL_IMG_WIDTH = 800;

/**
 *  S3 에 저장 될 상품 썸네일 이미지 높이
 */
export const PRODUCT_THUMBNAIL_IMG_HEIGHT = 800;

/**
 *  상품 메인 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_MAIN_IMG = 1;

/**
 *  상품 메인 이미지 최소 개수
 */
export const MINIMUM_NUMBER_OF_PRODUCT_MAIN_IMG = 1;

/**
 *  상품 서브 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_SUB_IMG = 5;

/**
 *  상품 상세 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG = 20;

/**
 *  상품 상세 이미지 최소 개수
 */
export const MINIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG = 1;

/**
 *  상품 착용 시 주의 사항 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_CAUTIONS_TEXT = 250;

/**
 *  상품 품질보증 기준 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_QUALITY_ASSURANCE_STANDARD_TEXT = 250;

/**
 *  상품 제조국 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_ORIGIN_TEXT = 15;

/**
 *  상품 제조사 주의 사항 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_MANUFACTURER_TEXT = 50;

/**
 *  주문 메시지 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_ORDER_EXAMPLE_MESSAGE = 50;

/**
 *  상품 승인 거절 사유 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_REJECT_REASON_TEXT = 700;

/**
 *  상품 금지 사유 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_BAN_REASON_TEXT = 700;

/**
 *  상품 재고가 무제한일 때 저장되는 VALUE
 */
export const PRODUCT_UNLIMITED_STOCK_VALUE = -1;

/**
 *  [상품 버전 비교 페이지] 현재 버전 섹션 타이틀
 */
export const PRODUCT_CURRENT_VERSION_SECTION_TITLE = '현재 버전';

/**
 *  [상품 버전 비교 페이지] 버전 섹션 id
 */
export const PRODUCT_VERSION_SECTION_ID = {
  /**
   *  현재 버전
   */
  CURRENT_VERSION_SECTION: 'current-version-section-id',
  /**
   *  타켓 버전
   */
  TARGET_VERSION_SECTION: 'target-version-section-id',
};

/**
 *  [상품 버전 비교 페이지] 버전 섹션 id 리스트
 */
export const PRODUCT_VERSION_SECTION_ID_LIST = [
  PRODUCT_VERSION_SECTION_ID.CURRENT_VERSION_SECTION,
  PRODUCT_VERSION_SECTION_ID.TARGET_VERSION_SECTION,
];

/**
 *  상품 리스트가 없을 때 보여주는 텍스트
 */
export const PRODUCT_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 상품 리스트가 없습니다.';

/**
 *  상품 태그를 검수 할 상품 리스트가 없을 때 보여주는 텍스트
 */
export const PRODUCT_TAG_REQUEST_LIST_TABLE_EMPTY_TEXT =
  '요청하신 검색 필터로 검색된 상품 태그를 검수 할 상품 리스트가 없습니다.';

/**
 *  옵션 리스트가 없을 때 보여주는 텍스트
 */
export const PRODUCT_OPTION_LIST_TABLE_EMPTY_TEXT = '옵션 리스트가 없습니다.';

/**
 *  상품 배송 방법 타입
 */
export const PRODUCT_DELIVERY_TYPE = {
  /**
   *  일반 배송
   */
  GENERAL_DELIVERY: 0,
  /**
   *  바로 배송
   */
  DIRECT_DELIVERY: 1,
};

/**
 *  상품 배송 방법 타입 텍스트
 */
export const PRODUCT_DELIVERY_TYPE_TEXT = {
  [PRODUCT_DELIVERY_TYPE.GENERAL_DELIVERY]: '일반 배송 상품',
  [PRODUCT_DELIVERY_TYPE.DIRECT_DELIVERY]: '바로 배송 상품',
};

/**
 *  주문 시 제작 텍스트
 */
export const PRODUCT_ORDER_MADE_TYPE_TEXT = '주문 제작 상품';

/**
 *  상품 배송 방법 타입 SELECT LIST
 */
export const PRODUCT_DELIVERY_TYPE_SELECT_LIST = [
  {
    id: PRODUCT_DELIVERY_TYPE.GENERAL_DELIVERY,
    name: PRODUCT_DELIVERY_TYPE_TEXT[PRODUCT_DELIVERY_TYPE.GENERAL_DELIVERY],
  },
  {
    id: PRODUCT_DELIVERY_TYPE.DIRECT_DELIVERY,
    name: PRODUCT_DELIVERY_TYPE_TEXT[PRODUCT_DELIVERY_TYPE.DIRECT_DELIVERY],
  },
];

/**
 *  주문 제작 시 소요되는 일자 SELECT LIST
 */
export const ORDER_MADE_DATE_SELECT_LIST = [
  {
    id: 3,
    name: 3,
  },
  {
    id: 4,
    name: 4,
  },
  {
    id: 5,
    name: 5,
  },
  {
    id: 6,
    name: 6,
  },
  {
    id: 7,
    name: 7,
  },
  {
    id: 8,
    name: 8,
  },
  {
    id: 9,
    name: 9,
  },
  {
    id: 10,
    name: 10,
  },
  {
    id: 11,
    name: 11,
  },
  {
    id: 12,
    name: 12,
  },
  {
    id: 13,
    name: 13,
  },
  {
    id: 14,
    name: 14,
  },
];

/**
 *  주문 제작 시 소요되는 일자 기본값
 */
export const DEFAULT_ORDER_MADE_DATE = 3;

/**
 *  바로 배송 기준 시간 SELECT LIST
 */
export const DIRECT_DELIVERY_TIME_LIMIT = [
  {
    id: 0,
    name: '00:00',
  },
  {
    id: 1,
    name: '01:00',
  },
  {
    id: 2,
    name: '02:00',
  },
  {
    id: 3,
    name: '03:00',
  },
  {
    id: 4,
    name: '04:00',
  },
  {
    id: 5,
    name: '05:00',
  },
  {
    id: 6,
    name: '06:00',
  },
  {
    id: 7,
    name: '07:00',
  },
  {
    id: 8,
    name: '08:00',
  },
  {
    id: 9,
    name: '09:00',
  },
  {
    id: 10,
    name: '10:00',
  },
  {
    id: 11,
    name: '11:00',
  },
  {
    id: 12,
    name: '12:00',
  },
  {
    id: 13,
    name: '13:00',
  },
  {
    id: 14,
    name: '14:00',
  },
  {
    id: 15,
    name: '15:00',
  },
  {
    id: 16,
    name: '16:00',
  },
  {
    id: 17,
    name: '17:00',
  },
  {
    id: 18,
    name: '18:00',
  },
  {
    id: 19,
    name: '19:00',
  },
  {
    id: 20,
    name: '20:00',
  },
  {
    id: 21,
    name: '21:00',
  },
  {
    id: 22,
    name: '22:00',
  },
  {
    id: 23,
    name: '23:00',
  },
];

/**
 *  바로 배송 기준 시간 기본값
 */
export const DEFAULT_DIRECT_DELIVERY_TIME_LIMIT = 12;

/**
 *  일반 배송 시 소요되는 일자
 */
export const GENERAL_DELIVERY_REQUIRED_DATE = 3;

/**
 *  주문 제작 상품인 경우,
 *  발송 처리부일로부터 배송 완료 일시까지 소요되는 시간을
 *  더해주는 일자값
 */
export const ORDER_MADE_DELIVERY_COMPLETE_ADDITIONAL_DATE = 2;

/**
 *  상품 가격 검색 리스트
 */
export const PRODUCT_SEARCH_PRICE_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 1,
    value: {
      startPrice: 0,
      endPrice: 10000,
    },
  },
  {
    id: 2,
    value: {
      startPrice: 10000,
      endPrice: 30000,
    },
  },
  {
    id: 3,
    value: {
      startPrice: 30000,
      endPrice: 50000,
    },
  },
  {
    id: 4,
    value: {
      startPrice: 50000,
      endPrice: 100000,
    },
  },
  {
    id: 5,
    value: {
      startPrice: 100000,
      endPrice: PRODUCT_MAXIMUM_PRICE,
    },
  },
  {
    id: 6,
    value: {
      startPrice: 0,
      endPrice: PRODUCT_MAXIMUM_PRICE,
    },
  },
];

/**
 *  가격 checkbox 버튼 리스트
 */
export const PRODUCT_SEARCH_PRICE_CHECK_BOX_LIST = [
  {
    id: 1,
    name: '1만원 이하',
    value: {
      startPrice: 0,
      endPrice: 10000,
    },
  },
  {
    id: 2,
    name: '1만원 ~ 3만원',
    value: {
      startPrice: 10000,
      endPrice: 30000,
    },
  },
  {
    id: 3,
    name: '3만원 ~ 5만원',
    value: {
      startPrice: 30000,
      endPrice: 50000,
    },
  },
  {
    id: 4,
    name: '5만원 ~ 10만원',
    value: {
      startPrice: 50000,
      endPrice: 100000,
    },
  },
  {
    id: 5,
    name: '10만원 이상',
    value: {
      startPrice: 100000,
      endPrice: PRODUCT_MAXIMUM_PRICE,
    },
  },
  {
    id: 6,
    name: '직접입력',
    value: {
      startPrice: 0,
      endPrice: PRODUCT_MAXIMUM_PRICE,
    },
  },
];

/**
 *  가격 SELECT 리스트
 */
export const PRODUCT_SEARCH_PRICE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 1,
    name: '1만원 이하',
    value: {
      startPrice: 0,
      endPrice: 10000,
    },
  },
  {
    id: 2,
    name: '1만원 ~ 3만원',
    value: {
      startPrice: 10000,
      endPrice: 30000,
    },
  },
  {
    id: 3,
    name: '3만원 ~ 5만원',
    value: {
      startPrice: 30000,
      endPrice: 50000,
    },
  },
  {
    id: 4,
    name: '5만원 ~ 10만원',
    value: {
      startPrice: 50000,
      endPrice: 100000,
    },
  },
  {
    id: 5,
    name: '10만원 이상',
    value: {
      startPrice: 100000,
      endPrice: PRODUCT_MAXIMUM_PRICE,
    },
  },
  {
    id: 6,
    name: '직접입력',
    value: {
      startPrice: 0,
      endPrice: PRODUCT_MAXIMUM_PRICE,
    },
  },
];

/**
 *  할인율 검색 checkbox 리스트
 */
export const PRODUCT_SEARCH_RATE_CHECK_BOX_LIST = [
  {
    id: 1,
    name: '10% 이하',
    value: {
      startRate: 0,
      endRate: 10,
    },
  },
  {
    id: 2,
    name: '10% ~ 20%',
    value: {
      startRate: 10,
      endRate: 20,
    },
  },
  {
    id: 3,
    name: '20% ~ 30%',
    value: {
      startRate: 20,
      endRate: 30,
    },
  },
  {
    id: 4,
    name: '30% ~ 40%',
    value: {
      startRate: 30,
      endRate: 40,
    },
  },
  {
    id: 5,
    name: '40% 이상',
    value: {
      startRate: 40,
      endRate: PRODUCT_MAXIMUM_DISCOUNT_RATE,
    },
  },
  {
    id: 6,
    name: '직접입력',
    value: {
      startRate: 0,
      endRate: PRODUCT_MAXIMUM_DISCOUNT_RATE,
    },
  },
];

/**
 *  할인 설정 Button 리스트
 */
export const PRODUCT_DISCOUNT_BUTTON_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '원',
    value: DISCOUNT_TYPE.FIXED_AMOUNT_DISCOUNT,
  },
  {
    id: 1,
    name: '%',
    value: DISCOUNT_TYPE.FIXED_RATE_DISCOUNT,
  },
];

/**
 *  일괄 상품 할인 편집 시 유효하지 않은 경우 타입
 */
export const INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE = {
  /**
   *  유효하지 않은 상품번호
   */
  INVALID_PRODUCT_ID: 0,
  /**
   *  중복되는 상품번호
   */
  DUPLICATE_PRODUCT_ID: 1,
  /**
   *  유효하지 않은 상품상태
   */
  INVALID_PRODUCT_STATUS: 2,
  /**
   *  유효하지 않은 할인 단위
   */
  INVALID_PRODUCT_DISCOUNT_TYPE: 3,
  /**
   *  유효하지 않은 할인 값
   */
  INVALID_PRODUCT_DISCOUNT_VALUE: 4,
  /**
   *  할인 단위가 "원"(0) 인데, 할인값이 10원 단위가 아닌경우
   */
  INVALID_PRODUCT_DISCOUNT_AMOUNT: 5,
  /**
   *  주얼리가 아닌 상품의 할인된 가격이 2,000원 보다 낮은 경우
   */
  INVALID_NON_JEWELRY_PRODUCT_SALES_PRICE: 6,
  /**
   *  주얼리 상품의 할인된 가격이 9,900원 보다 낮은 경우
   */
  INVALID_JEWELRY_PRODUCT_SALES_PRICE: 7,
  /**
   *  할인 단위가 "%"(1) 인데, 할인값이 1~99 사이의 값이 아닌경우
   */
  INVALID_PRODUCT_DISCOUNT_RATE: 8,
  /**
   *  유효하지 않은 할인 시작일의 날짜 형식
   */
  INVALID_PRODUCT_DISCOUNT_START_DATE: 9,
  /**
   *  유효하지 않은 할인 종료일의 날짜 형식
   */
  INVALID_PRODUCT_DISCOUNT_END_DATE: 10,
  /**
   *  유효하지 않은 할인 기간
   */
  INVALID_PRODUCT_DISCOUNT_PERIOD_DATE: 11,
};

/**
 *  일괄 상품 할인 편집 시 유효하지 않은 경우 타입 텍스트
 */
export const INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 상품번호
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_ID]: '유효하지 않은 상품번호입니다.',
  /**
   *  중복되는 상품번호
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.DUPLICATE_PRODUCT_ID]: '일괄 변경할 상품번호가 중복됩니다.',
  /**
   *  유효하지 않은 상품상태
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_STATUS]:
    '일괄 변경할 상품의 상태는 판매 중, 품절, 판매 중지만 가능합니다.',
  /**
   *  유효하지 않은 할인 단위
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_TYPE]:
    "상품 할인 단위는 '%' 또는 '원'만 가능합니다.",
  /**
   *  유효하지 않은 할인 값
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_VALUE]: '할인 값은 숫자만 입력 가능합니다.',
  /**
   *  할인 단위가 "원"(0) 인데, 할인값 이 10원 단위가 아닌경우
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_AMOUNT]: '할인 값은 10원 단위만 가능합니다.',
  /**
   *  주얼리가 아닌 상품의 할인된 가격이 2000원 보다 낮은 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_NON_JEWELRY_PRODUCT_SALES_PRICE]: `주얼리가 아닌 상품의 할인된 가격은 2,000원이상이여야 합니다.`,
  /**
   *  주얼리 상품의 할인된 가격이 9,900원 보다 낮은 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_JEWELRY_PRODUCT_SALES_PRICE]: `주얼리 상품의 할인된 가격은 9,900원이상이여야 합니다.`,
  /**
   *  할인 단위가 "%"(1) 인데, 할인값이 1~99 사이의 값이 아닌경우
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_RATE]:
    '할인 값은 1% 이상 99% 이하만 가능합니다.',
  /**
   *  유효하지 않은 할인 시작일의 날짜 형식
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_START_DATE]:
    '할인 시작일의 날짜 형식은 날짜 셀서식만 가능합니다.',
  /**
   *  유효하지 않은 할인 종료일의 날짜 형식
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_END_DATE]:
    '할인 종료일의 날짜 형식은 날짜 셀서식만 가능합니다.',
  /**
   *  유효하지 않은 할인 기간
   */
  [INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_PERIOD_DATE]: '유효하지 않은 할인 기간입니다.',
};

/**
 *  일괄 상품 할인 편집 시 유효하지 않은 경우 타입 텍스트
 */
export const VALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TEXT = '할인 변경이 가능합니다.';

/**
 *  상품 이미지 타입
 */
export const PRODUCT_ATTACHMENT_TYPE = {
  /**
   *  메인 이미지
   */
  MAIN_IMG: 0,
  /**
   *  추가 이미지
   */
  SUB_IMG: 1,
  /**
   *  상세 이미지
   */
  DETAIL_IMG: 2,
  /**
   *  영상
   */
  VIDEO: 100,
};

/**
 *  일괄 상품 편집 시 유효하지 않은 경우 타입
 */
export const INVALID_BULK_EDIT_PRODUCT_CASE_TYPE = {
  /**
   *  필수 값
   */
  INVALID_REQUIRED: 0,
  /**
   *  카테고리가 귀걸이인 경우에만 입력 가능
   */
  INVALID_REQUIRED_FROM_CATEGORY_IS_EARRING: 1,
  /**
   *  숫자 타입만 가능
   */
  INVALID_DATA_TYPE_NUMBER: 2,
  /**
   *  날짜 형식이 유효하지 않음
   */
  INVALID_DATE_TYPE_DATE: 3,
  /**
   *  존재하지 않은 값
   */
  INVALID_VALUE: 4,
  /**
   *  중복된 값
   */
  INVALID_DUPLICATE_VALUE: 5,
  /**
   *  10원 단위만 입력 가능
   */
  INVALID_TEN_WON_UNIT: 6,
  /**
   *  Y 또는 N 으로만 입력 가능
   */
  INVALID_SIMPLE_RESPONSE: 7,
  /**
   *  입력한 태그가 없음
   */
  INVALID_TAG_EMPTY: 8,
  /**
   *  일괄 변경할 상품의 상태가 판매중, 품절, 판매중지인 경우만 일괄 편집 가능
   */
  INVALID_PRODUCT_AVAILABLE_STATUS: 9,
  /**
   *  판매중, 품절, 판매중지 상태로만 변경 가능
   */
  INVALID_PRODUCT_EDIT_STATUS: 10,
  /**
   *  상품명 길이가 35자 초과인 경우
   */
  INVALID_PRODUCT_NAME_MAXIMUM_SIZE: 11,
  /**
   *  비 주얼리 상품의 판매가가 2,000원 보다 낮거나 5,000,000원 보다 큰 경우
   */
  INVALID_NON_JEWELRY_PRODUCT_ORIGIN_PRICE: 12,
  /**
   *  주얼리 상품의 판매가가 9,900원 보다 낮거나 5,000,000원 보다 큰 경우
   */
  INVALID_JEWELRY_PRODUCT_ORIGIN_PRICE: 13,
  /**
   *  유효하지 않은 할인 단위
   */
  INVALID_PRODUCT_DISCOUNT_TYPE: 14,
  /**
   *  할인 단위가 "%"(1) 인데, 할인값이 1~99 사이의 값이 아닌경우
   */
  INVALID_PRODUCT_DISCOUNT_RATE_RANGE: 15,
  /**
   *  할인 단위가 "원" 일때, 최소 값은 10원
   */
  INVALID_PRODUCT_DISCOUNT_AMOUNT_MINIMUM_PRICE: 16,
  /**
   *  비 주얼리 상품의 할인된 가격이 2,000원 보다 낮은 경우
   */
  INVALID_NON_JEWELRY_PRODUCT_SALES_PRICE: 17,
  /**
   *  주얼리 상품의 할인된 가격이 9,900원 보다 낮은 경우
   */
  INVALID_JEWELRY_PRODUCT_SALES_PRICE: 18,
  /**
   *  할인 종료일이 할인 시작일보다 이전일 경우
   */
  INVALID_PRODUCT_DISCOUNT_END_DATE: 19,
  /**
   *  재고 수량이 0개 보다 작거나 10,000,000개 보다 큰 경우
   */
  INVALID_PRODUCT_STOCK_COUNT_MAXIMUM_SIZE: 20,
  /**
   *  유효하지 않은 제품번호
   */
  INVALID_PRODUCT_NUMBER_MAXIMUM_SIZE: 21,
  /**
   *  상품옵션 분류의 길이가 25자를 초과한 경우
   */
  INVALID_PRODUCT_OPTION_TYPE_MAXIMUM_SIZE: 22,
  /**
   *  상품 옵션명은 최대 50자까지 가능
   */
  INVALID_PRODUCT_OPTION_NAME_MAXIMUM_SIZE: 23,
  /**
   *  주얼리가 아닌 상품의 옵션가가 2,000 - 판매가 - 할인가 미만이거나 5,000,000원 초과인 경우
   */
  INVALID_NON_JEWELRY_PRODUCT_OPTION_PRICE: 24,
  /**
   *  주얼리 상품의 옵션가가 9,900 - 판매가 - 할인가 미만이거나 5,000,000원 초과인 경우
   */
  INVALID_JEWELRY_PRODUCT_OPTION_PRICE: 25,
  /**
   *  상품 옵션 재고수량이 0개 보다 작거나 10,000,000개 보다 큰 경우
   */
  INVALID_PRODUCT_OPTION_STOCK_COUNT_RANGE: 26,
  /**
   *  상품 옵션 판매상태가 유효하지 않은 경우
   */
  INVALID_PRODUCT_EDIT_OPTION_STATUS: 27,
  /**
   *  상품 옵션 제품번호의 길이가 100자 초과한 경우
   */
  INVALID_PRODUCT_OPTION_NUMBER_MAXIMUM_SIZE: 28,
  /**
   *  상품 컨셉 태그는 최대 6개 입력 가능
   */
  INVALID_PRODUCT_CONCEPT_TAG_MAXIMUM_SIZE: 29,
  /**
   *  카테고리가 유효하지 않은 경우
   */
  INVALID_PRODUCT_CATEGORY: 30,
  /**
   *  카테고리에 맞지 않는 아이템 태그인 경우
   */
  INVALID_PRODUCT_ITEM_TAG: 31,
  /**
   *  두 착용 방법 중 1개는 Y를 입력해야 하는 경우
   */
  INVALID_REQUIRED_POST_EARRING_WEAR_TYPE: 32,
  /**
   *  소재/귀걸이침 태그를 입력했는데 귀걸이 착용방법이 침인 경우 를 Y라고 입력 안한 경우
   */
  INVALID_RELATED_POST_EARRING_TAG: 33,
  /**
   *  소재/베이스 태그에 "기타소재"를 입력 하지 않은 경우 입력 할 수 없음
   */
  INVALID_MATERIAL_ETC_TAG: 34,
  /**
   *  모양 태그는 최대 3개 입력 가능
   */
  INVALID_PRODUCT_SHAPE_TAG_MAXIMUM_SIZE: 35,
  /**
   *  시즌/상황 태그는 최대 3개 입력 가능
   */
  INVALID_PRODUCT_SEASON_STATUS_TAG_MAXIMUM_SIZE: 36,
  /**
   *  유효하지 않은 상품 사이즈
   */
  INVALID_PRODUCT_SIZE_MAXIMUM_SIZE: 37,
  /**
   *  유효하지 않은 상품 중량
   */
  INVALID_PRODUCT_WEIGHT_MAXIMUM_SIZE: 38,
  /**
   *  유효하지 않은 상품 구매 시 유의 사항
   */
  INVALID_PRODUCT_NOTICE_MAXIMUM_SIZE: 39,
  /**
   *  유효하지 않은 주문 메시지
   */
  INVALID_ORDER_EXAMPLE_MESSAGE_MAXIMUM_SIZE: 40,
  /**
   *  유효하지 않은 상품 배송타입
   */
  INVALID_PRODUCT_DELIVERY_TYPE: 41,
  /**
   *  배송타입이 "일반배송"이 아닌데 주문 시 제작 소요일을 입력한 경우
   */
  INVALID_PRODUCT_ORDER_MADE_DATE_REQUIRED_GENERAL_TYPE: 42,
  /**
   *  상품 주문시 제작 소요일이 3~14 사이의 값이 아닌경우
   */
  INVALID_PRODUCT_ORDER_MADE_DATE_RANGE: 43,
  /**
   *  배송타입이 "바로배송"이 아닌데 바로 배송 기준 시간을 입력한 경우
   */
  INVALID_PRODUCT_DIRECT_DELIVERY_DATE_REQUIRED_DIRECT_TYPE: 44,
  /**
   *  상품 바로 배송 기준 시간이 0~23 사이의 값이 아닌경우
   */
  INVALID_PRODUCT_DIRECT_DELIVERY_DATE_RANGE: 45,
  /**
   *  유효하지 않은 A/S안내
   */
  INVALID_PRODUCT_AS_INFORM_MAXIMUM_SIZE: 46,
  /**
   *  유효하지 않은 착용시 주의 사항
   */
  INVALID_PRODUCT_CAUTION_MAXIMUM_SIZE: 47,
  /**
   *  유효하지 않은 품질보증 기준
   */
  INVALID_PRODUCT_ASSURANCE_MAXIMUM_SIZE: 48,
  /**
   *  유효하지 않은 제조자
   */
  INVALID_PRODUCT_MANUFACTURER_MAXIMUM_SIZE: 49,
  /**
   *  유효하지 않은 제조국
   */
  INVALID_PRODUCT_ORIGIN_MAXIMUM_SIZE: 50,
};

/**
 *  일괄 상품 편집 시 유효하지 않은 경우 타입 텍스트
 */
export const INVALID_BULK_EDIT_PRODUCT_CASE_TYPE_TEXT = {
  /**
   *  필수 값
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_REQUIRED]: '필수 값 입니다.',
  /**
   *  카테고리가 귀걸이인 경우에만 입력 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_REQUIRED_FROM_CATEGORY_IS_EARRING]:
    '카테고리가 귀걸이인 경우에만 입력하실 수 있습니다.',
  /**
   *  숫자 타입만 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_DATA_TYPE_NUMBER]: '숫자만 입력 가능합니다.',
  /**
   *  날짜 형식이 유효하지 않음
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_DATE_TYPE_DATE]: "날짜 형식은 '예)2019-11-10'만 가능합니다.",
  /**
   *  존재하지 않은 값
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_VALUE]: '존재하지 않은 값 입니다.',
  /**
   *  중복된 값
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_DUPLICATE_VALUE]: '중복된 값 입니다.',
  /**
   *  10원 단위만 입력 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_TEN_WON_UNIT]: '10원 단위만 입력 가능합니다.',
  /**
   *  Y 또는 N 으로만 입력 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_SIMPLE_RESPONSE]: 'Y 또는 N만 입력 가능합니다.',
  /**
   *  입력한 태그가 없음
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_TAG_EMPTY]: '입력한 태그가 없습니다.',
  /**
   *  일괄 변경할 상품의 상태가 판매중, 품절, 판매중지인 경우만 일괄 편집 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_AVAILABLE_STATUS]:
    '상품의 상태가 판매중, 품절, 판매중지인 경우만 판매 상태를 편집 할 수 있습니다.',
  /**
   *  판매중, 품절, 판매중지 상태로만 변경 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_EDIT_STATUS]:
    '판매 중, 품절, 판매 중지로만 상태를 변경 가능합니다.',
  /**
   *  상품명 길이가 35자 초과인 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_NAME_MAXIMUM_SIZE]: '상품명은 최대 35자까지만 입력 가능합니다.',
  /**
   *  비 주얼리 상품의 판매가가 2,000원 보다 낮거나 5,000,000원 보다 큰 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_NON_JEWELRY_PRODUCT_ORIGIN_PRICE]:
    '팬던트, 뱃지, 브로치, 헤어 상품의 판매가는 2,000원이상 5,000,000원이하여야 합니다.',
  /**
   *  주얼리 상품의 판매가가 9,900원 보다 낮거나 5,000,000원 보다 큰 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_JEWELRY_PRODUCT_ORIGIN_PRICE]:
    '판매가는 9,900원이상 5,000,000원이하여야 합니다.',
  /**
   *  유효하지 않은 할인 단위
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_TYPE]:
    "상품 할인 단위는 '%' 또는 '원'만 입력 가능합니다.",
  /**
   *  할인 단위가 "%"(1) 인데, 할인값이 1~99 사이의 값이 아닌경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_RATE_RANGE]: '할인 값은 1% 이상 99% 이하만 가능합니다.',
  /**
   *  할인 단위가 "원" 일때, 최소 값은 10원
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_AMOUNT_MINIMUM_PRICE]:
    '할인 값은 최소 10원 이상만 가능합니다.',
  /**
   *  비 주얼리 상품의 할인된 가격이 2,000원 보다 낮은 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_NON_JEWELRY_PRODUCT_SALES_PRICE]:
    '팬던트, 뱃지, 브로치, 헤어 상품의 할인된 가격은 2,000원이상이여야 합니다.',
  /**
   *  주얼리 상품의 할인된 가격이 9,900원 보다 낮은 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_JEWELRY_PRODUCT_SALES_PRICE]: '할인된 가격은 9,900원 이상이여야 합니다.',
  /**
   *  할인 종료일이 할인 시작일보다 이전일 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DISCOUNT_END_DATE]:
    '할인 종료일이 할인 시작일 보다 이전일 수 없습니다.',
  /**
   *  재고 수량이 0개 보다 작거나 10,000,000개 보다 큰 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_STOCK_COUNT_MAXIMUM_SIZE]:
    '재고 수량은 0개이상 10,000,000개이하여야 합니다.',
  /**
   *  유효하지 않은 제품번호
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_NUMBER_MAXIMUM_SIZE]:
    '제품번호는 최대 100자까지 입력 가능합니다.',
  /**
   *  상품옵션 분류의 길이가 25자를 초과한 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_OPTION_TYPE_MAXIMUM_SIZE]:
    '상품옵션 분류는 최대 25자까지 입력 가능합니다.',
  /**
   *  상품 옵션명은 최대 50자까지 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_OPTION_NAME_MAXIMUM_SIZE]:
    '상품 옵션명은 최대 50자까지 입력 가능합니다.',
  /**
   *  주얼리가 아닌 상품의 옵션가가 2,000 - 판매가 - 할인가 미만이거나 5,000,000원 초과인 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_NON_JEWELRY_PRODUCT_OPTION_PRICE]:
    '상품 옵션가는 2,000 - [판매가] + [할인가] 이상 5,000,000원 - [판매가] + [할인가] 이하여야 합니다.',
  /**
   *  주얼리 상품의 옵션가가 9,900 - 판매가 - 할인가 미만이거나 5,000,000원 초과인 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_JEWELRY_PRODUCT_OPTION_PRICE]:
    '상품 옵션가는 9,900원 - [판매가] + [할인가] 이상 5,000,000원 - [판매가] + [할인가] 이하여야 합니다.',
  /**
   *  상품 옵션 재고수량이 0개 보다 작거나 10,000,000개 보다 큰 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_OPTION_STOCK_COUNT_RANGE]:
    '상품옵션의 재고 수량은 0개이상 10,000,000개이하여야 합니다.',
  /**
   *  상품 옵션 판매상태가 유효하지 않은 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_EDIT_OPTION_STATUS]:
    '상품 옵션의 판매상태는 비 노출, 노출, 품절중에 입력해야 합니다.',
  /**
   *  상품 옵션 제품번호의 길이가 100자 초과한 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_OPTION_NUMBER_MAXIMUM_SIZE]:
    '상품 옵션의 제품번호는 최대 100자까지 입력 가능합니다.',
  /**
   *  상품 컨셉 태그는 최대 6개 입력 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_CONCEPT_TAG_MAXIMUM_SIZE]:
    '상품 컨셉 태그는 최대 6개 입력 가능합니다.',
  /**
   *  카테고리가 유효하지 않은 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_CATEGORY]: '카테고리가 유효하지 않습니다.',
  /**
   *  카테고리에 맞지 않는 아이템 태그인 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_ITEM_TAG]: '카테고리에 해당되지 않는 아이템 태그 입니다.',
  /**
   *  두 착용 방법 중 1개는 Y를 입력해야 하는 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_REQUIRED_POST_EARRING_WEAR_TYPE]:
    '두 착용 방법 중 1개는 Y를 입력해야합니다.',
  /**
   *  소재/귀걸이침 태그를 입력했는데 귀걸이 착용방법이 침인 경우 를 Y라고 입력 안한 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_RELATED_POST_EARRING_TAG]:
    '소재/귀걸이침 태그를 입력한 경우 귀걸이 착용방법이 침인 경우를 Y라고 입력 해야합니다.',
  /**
   *  소재/베이스 태그에 "기타소재"를 입력 하지 않은 경우 입력 할 수 없음
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_MATERIAL_ETC_TAG]: `소재/베이스 태그에 "기타소재"를 입력 하지 않은 경우 입력 할 수 없습니다.`,
  /**
   *  모양 태그는 최대 3개 입력 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_SHAPE_TAG_MAXIMUM_SIZE]:
    '모양 태그는 최대 3개까지 입력 가능합니다.',
  /**
   *  시즌/상황 태그는 최대 3개 입력 가능
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_SEASON_STATUS_TAG_MAXIMUM_SIZE]:
    '시즌/상황 태그는 최대 3개까지 입력 가능합니다.',
  /**
   *  유효하지 않은 상품 사이즈
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_SIZE_MAXIMUM_SIZE]:
    '상품 사이즈는 최대 50자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 상품 중량
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_WEIGHT_MAXIMUM_SIZE]:
    '상품 중량은 최대 30자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 상품 구매 시 유의 사항
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_NOTICE_MAXIMUM_SIZE]:
    '구매 시 유의 사항은 최대 100자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 주문 메시지
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_ORDER_EXAMPLE_MESSAGE_MAXIMUM_SIZE]:
    '주문 메시지는 최대 50자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 상품 배송타입
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DELIVERY_TYPE]: '일반배송 또는 바로배송만 입력 가능합니다.',
  /**
   *  배송타입이 "일반배송"이 아닌데 주문 시 제작 소요일을 입력한 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_ORDER_MADE_DATE_REQUIRED_GENERAL_TYPE]:
    '배송타입이 일반 배송이여야 합니다.',
  /**
   *  상품 주문시 제작 소요일이 3~14 사이의 값이 아닌경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_ORDER_MADE_DATE_RANGE]:
    '주문시 제작 소요일은 3~14 만 입력 가능합니다.',
  /**
   *  배송타입이 "바로배송"이 아닌데 바로 배송 기준 시간을 입력한 경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DIRECT_DELIVERY_DATE_REQUIRED_DIRECT_TYPE]:
    '배송타입이 바로배송이여야 합니다.',
  /**
   *  상품 바로 배송 기준 시간이 0~23 사이의 값이 아닌경우
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_DIRECT_DELIVERY_DATE_RANGE]:
    '바로 배송 기준 시간은 0~23만 입력 가능합니다.',
  /**
   *  유효하지 않은 A/S안내
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_AS_INFORM_MAXIMUM_SIZE]:
    'A/S안내는 최대 3,000자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 착용시 주의 사항
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_CAUTION_MAXIMUM_SIZE]:
    '착용시 주의 사항은 최대 250자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 품질보증 기준
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_ASSURANCE_MAXIMUM_SIZE]:
    '품질보증 기준은 최대 250자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 제조자
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_MANUFACTURER_MAXIMUM_SIZE]:
    '제조자는 최대 50자까지 입력 가능합니다.',
  /**
   *  유효하지 않은 제조국
   */
  [INVALID_BULK_EDIT_PRODUCT_CASE_TYPE.INVALID_PRODUCT_ORIGIN_MAXIMUM_SIZE]: '제조국은 최대 15자까지 입력 가능합니다.',
};

/**
 *  상품 엑셀 일괄 편집 가능한 최대 상품수
 */
export const MAXIMUM_NUMBER_OF_BULK_EDIT_PRODUCT = 400;

/**
 *  상품 리스트 검색 키워드 타입
 */
export const PRODUCT_LIST_SEARCH_KEYWORD_TYPE = {
  /**
   *  브랜드
   */
  BRAND_NAME: 0,
  /**
   *  브랜드 ID
   */
  BRAND_ID: 1,
  /**
   *  상품명
   */
  PRODUCT_NAME: 2,
  /**
   *  상품 ID
   */
  PRODUCT_ID: 3,
  /**
   *  카테고리
   */
  CATEGORY: 4,
};

/**
 *  상품 리스트 검색 키워드 타입 텍스트
 */
export const PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT = {
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.BRAND_NAME]: '브랜드',
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.BRAND_ID]: '브랜드 ID',
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME]: '상품명',
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID]: '상품 ID',
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.CATEGORY]: '카테고리',
};

/**
 *  상품 리스트 검색 키워드 타입 SELECT LIST
 */
export const PRODUCT_LIST_SEARCH_KEYWORD_TYPE_SELECT_LIST = [
  {
    id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME,
    name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME],
  },
  {
    id: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID,
    name: PRODUCT_LIST_SEARCH_KEYWORD_TYPE_TEXT[PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID],
  },
];

export const BRAND_SEARCH_PARAMS_MAP = {
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME]: 'name',
  [PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_ID]: 'id',
};

/**
 *  선택 가능한 상품 컨셉 태그 개수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_CONCEPT_TAG = 6;

/**
 *  선택 가능한 모양 태그 개수
 */
export const MAXIMUM_NUMBER_OF_SHAPE_TAG = 3;

/**
 *  선택 가능한 시즌/상황 개수
 */
export const MAXIMUM_NUMBER_OF_SEASON_STATUS_TAG = 3;

/**
 *  상품 태그 승인 거절 타입
 */
export const PRODUCT_TAG_REJECT_TYPE = {
  /**
   *  상품 태그 부적합
   */
  INVALID_PRODUCT_TAG: 0,
};

/**
 *  상품 속성 승인 거절 타입 텍스트
 *  todo: 브랜드에서 사용중이라 임시적으로 제거 안함 - 확인 필요
 */
export const PRODUCT_TAG_REJECT_TYPE_TEXT = {
  /**
   *  상품 태그 부적합
   */
  [PRODUCT_TAG_REJECT_TYPE.INVALID_PRODUCT_TAG]: '상품 태그 부적합',
};

/**
 *  상품 태그 승인 거절 타입
 */
export const PRODUCT_PROPERTY_REJECT_TYPE = {
  /**
   *  상품 속성 부적합
   */
  INVALID_PRODUCT_PROPERTY: 0,
};

/**
 *  상품 속성 승인 거절 타입 텍스트
 */
export const PRODUCT_PROPERTY_REJECT_TYPE_TEXT = {
  /**
   *  상품 속성 부적합
   */
  [PRODUCT_PROPERTY_REJECT_TYPE.INVALID_PRODUCT_PROPERTY]: '상품 속성 부적합',
};

/**
 *  상품 속성 승인 거절 타입 SELECT 리스트
 */
export const PRODUCT_PROPERTY_REJECT_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: PRODUCT_PROPERTY_REJECT_TYPE.INVALID_PRODUCT_PROPERTY,
    name: PRODUCT_PROPERTY_REJECT_TYPE_TEXT[PRODUCT_PROPERTY_REJECT_TYPE.INVALID_PRODUCT_PROPERTY],
  },
];

/**
 *  상품 태그 승인 거절 사유 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_PRODUCT_TAG_REJECT_REASON_TEXT = 700;

/**
 *  상품 타입
 */
export const PRODUCT_MANAGEMENT_TYPE = {
  /**
   *  입점상품
   */
  ENTER: 0,
  /**
   *  사입상품
   */
  PURCHASE: 1,
  /**
   *  입고상품
   */
  INCOME: 2,
  /**
   *  위탁생산
   */
  CONSIGNMENT_MANUFACTURE: 3,
  /**
   *  위탁판매
   */
  CONSIGNMENT_SALE: 4,
};

/**
 *  상품 관리 타입 텍스트
 */
export const PRODUCT_MANAGEMENT_TYPE_TEXT = {
  /**
   *  입점상품
   */
  [PRODUCT_MANAGEMENT_TYPE.ENTER]: '입점상품',
  /**
   *  사입상품
   */
  [PRODUCT_MANAGEMENT_TYPE.PURCHASE]: '사입상품',
  /**
   *  입고상품
   */
  [PRODUCT_MANAGEMENT_TYPE.INCOME]: '입고상품',
  /**
   *  위탁생산
   */
  [PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE]: '위탁생산',
  /**
   *  위탁판매
   */
  [PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_SALE]: '위탁판매',
};

/**
 *  상품 관리 타입 SELECT LIST
 */
export const PRODUCT_MANAGEMENT_TYPE_SELECT_LIST = [
  {
    id: PRODUCT_MANAGEMENT_TYPE.ENTER,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.ENTER],
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.PURCHASE,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.PURCHASE],
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.INCOME,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.INCOME],
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE],
  },
  // {
  //     id: PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_SALE,
  //     name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_SALE],
  // },
];

/**
 *  아몬즈 상품 관리 타입 SELECT LIST
 */
export const AMONDZ_PRODUCT_MANAGEMENT_TYPE_SELECT_LIST = [
  {
    id: PRODUCT_MANAGEMENT_TYPE.ENTER,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.ENTER],
    disabled: false,
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.INCOME,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.INCOME],
    disabled: true,
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.PURCHASE,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.PURCHASE],
    disabled: true,
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE],
    disabled: true,
  },
];

/**
 *  재고 복구 시 상품 상태 SELECT 리스트
 */
export const PRODUCT_STOCK_RECOVER_PRODUCT_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_STATUS.NOW_ON_SALE,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.NOW_ON_SALE],
  },
  {
    id: PRODUCT_STATUS.SOLD_OUT,
    name: PRODUCT_STATUS_TEXT[PRODUCT_STATUS.SOLD_OUT],
  },
];

/**
 *  재고 복구 시 상품 옵션 상태 SELECT 리스트
 */
export const PRODUCT_OPTION_STOCK_RECOVER_PRODUCT_STATUS_SELECT_LIST = [
  {
    id: PRODUCT_OPTION_STATUS.ACTIVE,
    name: PRODUCT_OPTION_STATUS_TEXT[PRODUCT_OPTION_STATUS.ACTIVE],
  },
  {
    id: PRODUCT_OPTION_STATUS.SOLD_OUT,
    name: PRODUCT_OPTION_STATUS_TEXT[PRODUCT_OPTION_STATUS.SOLD_OUT],
  },
];

/**
 *  풀필먼트 상품 관리 타입 리스트
 */
export const FULFILLMENT_PRODUCT_MANAGEMENT_TYPE_LIST = [
  /**
   *  입고상품
   */
  PRODUCT_MANAGEMENT_TYPE.INCOME,
  /**
   *  사입상품
   */
  PRODUCT_MANAGEMENT_TYPE.PURCHASE,
  /**
   *  위탁생산
   */
  PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE,
];

/**
 *  상품 결제 타입
 */
export const PRODUCT_PAY_METHOD_TYPE = {
  /**
   *  일반 상품
   */
  GENERAL: 1,
  /**
   *  24K Gold 상품
   */
  GOLD: 2,
  /**
   *  포인트 구매상품
   */
  POINT: 3,
};

/**
 *  상품 결제 타입 TEXT
 */
export const PRODUCT_PAY_METHOD_TYPE_TEXT = {
  [PRODUCT_PAY_METHOD_TYPE.GENERAL]: '일반 상품',
  [PRODUCT_PAY_METHOD_TYPE.GOLD]: '24K Gold 상품',
  [PRODUCT_PAY_METHOD_TYPE.POINT]: '포인트 구매상품',
};

/**
 *  상품 결제 타입 SELECT LIST
 */
export const PRODUCT_PAY_METHOD_TYPE_SELECT_LIST = [
  {
    id: PRODUCT_PAY_METHOD_TYPE.GENERAL,
    name: PRODUCT_PAY_METHOD_TYPE_TEXT[PRODUCT_PAY_METHOD_TYPE.GENERAL],
  },
  {
    id: PRODUCT_PAY_METHOD_TYPE.GOLD,
    name: PRODUCT_PAY_METHOD_TYPE_TEXT[PRODUCT_PAY_METHOD_TYPE.GOLD],
  },
  {
    id: PRODUCT_PAY_METHOD_TYPE.POINT,
    name: PRODUCT_PAY_METHOD_TYPE_TEXT[PRODUCT_PAY_METHOD_TYPE.POINT],
  },
];

/**
 *  상품 결제 수단 SELECT LIST
 */
export const PRODUCT_PAY_METHOD_SELECT_LIST = [
  {
    id: PAY_METHOD_TYPE.CARD,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.CARD],
  },
  {
    id: PAY_METHOD_TYPE.TRANS,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.TRANS],
  },
  {
    id: PAY_METHOD_TYPE.VBANK,
    name: PAY_METHOD_TYPE_TEXT[PAY_METHOD_TYPE.VBANK],
  },
];

/**
 *  상품 결제수단 값 타입
 */
export const PRODUCT_PAY_METHOD_VALUE_TYPE = {
  /**
   *  사용 안함
   */
  UN_USED: 0,
  /**
   *  전체
   */
  ALL: 1,
  /**
   *  일부
   */
  PART: 2,
};

/**
 *  상품 결제수단 값 타입 TEXT
 */
export const PRODUCT_PAY_METHOD_VALUE_TYPE_TEXT = {
  /**
   *  전체
   */
  [PRODUCT_PAY_METHOD_VALUE_TYPE.ALL]: '전체',
  /**
   *  일부
   */
  [PRODUCT_PAY_METHOD_VALUE_TYPE.PART]: '일부',
};

/**
 *  상품 결제 카드 옵션 버튼 리스트
 */
export const PRODUCT_PAY_CARD_OPTION_BUTTON_LIST = [
  {
    id: PRODUCT_PAY_METHOD_VALUE_TYPE.ALL,
    name: PRODUCT_PAY_METHOD_VALUE_TYPE_TEXT[PRODUCT_PAY_METHOD_VALUE_TYPE.ALL],
  },
  {
    id: PRODUCT_PAY_METHOD_VALUE_TYPE.PART,
    name: PRODUCT_PAY_METHOD_VALUE_TYPE_TEXT[PRODUCT_PAY_METHOD_VALUE_TYPE.PART],
  },
];

/**
 *  결제수단명 to 결제수단타입
 */
export const PAY_METHOD_NAME_TO_PAYMENT_METHOD_TYPE = {
  [PAYMENT_METHOD_TYPE_TO_KEY[PAY_METHOD_TYPE.CARD]]: PAY_METHOD_TYPE.CARD,
  [PAYMENT_METHOD_TYPE_TO_KEY[PAY_METHOD_TYPE.TRANS]]: PAY_METHOD_TYPE.TRANS,
  [PAYMENT_METHOD_TYPE_TO_KEY[PAY_METHOD_TYPE.VBANK]]: PAY_METHOD_TYPE.VBANK,
};

/**
 *  상품 결제수단타입 key 리스트
 */
export const PRODUCT_DETAIL_PAYMENT_METHOD_TYPE_KEY_LIST = [
  PAYMENT_METHOD_TYPE_TO_KEY[PAY_METHOD_TYPE.CARD],
  PAYMENT_METHOD_TYPE_TO_KEY[PAY_METHOD_TYPE.TRANS],
  PAYMENT_METHOD_TYPE_TO_KEY[PAY_METHOD_TYPE.VBANK],
];

/**
 * 상품 속성 default list
 */
export const DEFAULT_PRODUCT_PROPERTY = {
  name: '',
  list: [],
};

/**
 * proInfo - 상품 속성 default list
 */
export const DEFAULT_PRO_PROPERTY = {
  name: '',
  list: {
    active: [],
    confirmReady: null,
    reject: null,
  },
  rejectInfo: {},
};

/**
 * 상품정보 외부 채널
 */
export const EXTERNAL_CHANNEL = {
  // 사방넷
  SABANGNET: 'SABANGNET',
};

/**
 * 상품정보 외부 채널 액션 타입
 */
export const PRODUCT_EXTERNAL_ACTION_TYPE = {
  REGISTER: 'REGISTER',
  UPDATE: 'UPDATE',
};

/**
 * 상품정보 외부 채널 결과
 */
export const EXTERNAL_RESULT_STATUS = {
  // 성공
  SUCCESS: 'SUCCESS',
};
